var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkOut = function SvgLinkOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M13 5V1m0 0H9m4 0L7.667 6.333m-2-4H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C1 3.853 1 4.413 1 5.533V9.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 13 3.08 13 4.2 13h4.267c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V8.333"
  })));
};
export default SvgLinkOut;